import { render, staticRenderFns } from "./PoliciesModal.vue?vue&type=template&id=3c1dc112"
import script from "./PoliciesModal.vue?vue&type=script&lang=ts"
export * from "./PoliciesModal.vue?vue&type=script&lang=ts"
import style0 from "./PoliciesModal.vue?vue&type=style&index=0&id=3c1dc112&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports